import React from 'react';
import Loader from '../components/Loader';

const FullScreenLoading = () => <Loader fullScreen />;

export default FullScreenLoading;
